import list from './list'
import common from './common'
import book from './book'
import detail from './detail'
import filter from './filter'

export default {
  list,
  common,
  book,
  detail,
  filter
}
